import Spacer from '@/common/components/spacer';
import webpWithPngFallback from '@/common/utils/webp-with-png-fallback';
import ArrowWithTailRight from '@/icons/arrow-with-tail-right';
import { colors } from '@/theme/colors';

interface GasSaverTileProps {
  PUBLIC_CDN_URL: string;
  doesSupportWebp: boolean;
  gasSaverCents: string;
}

export default function GasSaverTile({
  PUBLIC_CDN_URL,
  doesSupportWebp,
  gasSaverCents,
}: GasSaverTileProps) {
  const is30CentsCopy = gasSaverCents.includes('30');
  const imageUrl = webpWithPngFallback(
    is30CentsCopy
      ? `${PUBLIC_CDN_URL}/web/images/marketing-tiles/gas-saver-30c.webp`
      : `${PUBLIC_CDN_URL}/web/images/marketing-tiles/gas-saver-20c.webp`,
    doesSupportWebp
  );

  return (
    <div className="relative aspect-square h-full w-full">
      <div className="absolute inset-0 rounded-[16px] bg-[linear-gradient(to_right,#FFDF75_0%,#FFBB80_20%,#FF9F8A_40%,#FE8F9E_60%,#FE85B8_80%,#FE80DB_100%)] p-[1px] transition-shadow hover:shadow-shadow30">
        <div className="relative flex h-full w-full flex-col justify-end overflow-hidden rounded-[16px] bg-flexcar-blue10">
          <img
            src={imageUrl}
            alt="Gas Saver Promotion"
            className="absolute inset-0 z-0 h-full w-full object-cover object-right-top"
            fetchPriority="high"
            loading="eager"
          />
          <div className="relative z-1 p-[24px]">
            <h1 className="text-left text-[18px] leading-[22px] tracking-[-0.09px] text-flexcar-neutral100">
              Flexcar Gas Saver™
            </h1>
            <Spacer variant="height8" />
            <p className="body2 text-left text-flexcar-neutral100">
              Save {gasSaverCents} per gallon on every fill-up at Sunoco.
            </p>
            <Spacer variant="height16" />
            <p className="body2 flex flex-row items-center justify-end gap-[4px] text-flexcar-neutral100">
              Learn more
              <ArrowWithTailRight
                fillPrimary={colors.neutral100}
                className="h-[16px] w-[20px]"
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
